import { identityTypeMap } from 'src/const/state/creative';
import * as types from '../../types';

export default {
  namespaced: true,
  state: {
    isNotHasCustom: false,
    validateField: null,
    addForm: {
      identity_type: identityTypeMap.FAKE_USER,
      display_name: '',
      avatar_icon: {},
    },
  },
  mutations: {
    [types.SET_ADD_FORM_IDENTITY](state, { prop, value }) {
      state.addForm[prop] = value;
    },
    [types.SET_ADD_FORM_IDENTITY_ALL](state, data) {
      state.addForm = data;
    },
    [types.SET_CUSTOM_VALIDATE_FIELD](state, { validateField }) {
      state.validateField = validateField;
    },
    [types.SET_IS_NOT_HAS_CUSTOM](state, type) {
      state.isNotHasCustom = type;
    },
  },
  actions: {

  },
  getters: {

  },
};
